import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import DashboardNavbar from "common/Navbars/DashboardNavbar";
import Footer from "common/Footer";
import DataTable from "common/Tables/DataTable";
import pendingAccountsTableData from "layouts/tables/data/pendingAccountsTableData";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPendingAccounts, pendingAction } from "store/slice/dealersSlice";
import { Modal, Button, Typography, Box, Alert, Snackbar } from "@mui/material";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function Dealers() {
    const dispatch = useDispatch();
    const dealers = useSelector((store) => store.dealers);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [dealerToReject, setDealerToReject] = useState(null);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");


    useEffect(() => {
        dispatch(getPendingAccounts());
    }, [dispatch]);

    const handleRejectClick = (dealer) => {
        setDealerToReject(dealer);
        setIsModalOpen(true);
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        setDealerToReject(null);
    };

    const handleConfirmReject = async () => {
        try {
            await dispatch(pendingAction({ dealerId: dealerToReject.id, approved: 0 }));
            setSnackbarMessage("Dealer rejected successfully");
            setSnackbarSeverity("success");
        } catch (error) {
            console.error("Error rejecting dealer:", error);
            setSnackbarMessage("Error rejecting dealer");
            setSnackbarSeverity("error");
        } finally {
            setIsModalOpen(false);
            setDealerToReject(null);
            setSnackbarOpen(true);
        }
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setSnackbarOpen(false);
    };

    const tableData = pendingAccountsTableData({
        dealers: dealers?.pendingAccounts || [],
        dispatch,
        handleRejectClick,
    });

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item size={{xs: 12}}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Pending Accounts
                                </MDTypography>
                            </MDBox>
                            <MDBox pt={3}>
                                <DataTable
                                    table={tableData}
                                    isSorted={false}
                                    entriesPerPage={false}
                                    showTotalEntries={false}
                                    noEndBorder
                                />
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Modal
                open={isModalOpen}
                onClose={handleModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Confirm Rejection
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        Are you sure you want to reject {dealerToReject?.name}?
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                        <Button onClick={handleModalClose} sx={{ mr: 1 }}>Cancel</Button>
                        <Button variant="contained" color="error" onClick={handleConfirmReject}>Confirm</Button>
                    </Box>
                </Box>
            </Modal>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            >
                <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: "100%" }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
            <Footer />
        </DashboardLayout>
    );
}

export default Dealers;